import type { ComponentPropsWithoutRef, ReactElement } from 'react'
import { controlClassName, isAriaInvalid } from './control-classes.ts'

/**
 * A multi-line text control, same contract as `Input`: dumb, native, and
 * wired by whatever `Field` hands it.
 *
 * `rows` defaults to 4 rather than the browser's 2. Most multi-line values
 * in this app are a description, a reason-for-access, or a block of YAML,
 * and a two-line box makes all three unreadable without resizing.
 */

export interface TextareaProps extends Omit<
  ComponentPropsWithoutRef<'textarea'>,
  'className'
> {
  /** For machine text — a buildspec fragment, an argv list, a key block. */
  isMono?: boolean
}

export function Textarea({
  isMono = false,
  rows = 4,
  ...rest
}: TextareaProps): ReactElement {
  return (
    <textarea
      rows={rows}
      className={`py-1.5 ${controlClassName({
        isInvalid: isAriaInvalid(rest['aria-invalid']),
        isMono,
      })}`}
      {...rest}
    />
  )
}
